import { render, staticRenderFns } from "./TabelaCarsInseridosNoContrato.vue?vue&type=template&id=b67dbdf8&lang=pug"
import script from "./TabelaCarsInseridosNoContrato.vue?vue&type=script&lang=js"
export * from "./TabelaCarsInseridosNoContrato.vue?vue&type=script&lang=js"
import style0 from "./TabelaCarsInseridosNoContrato.vue?vue&type=style&index=0&id=b67dbdf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports